<template>
  <div class="zzl-container">
    <div class="zzl-content">
      <div class="zzl-title">菜单管理</div>
      <div class="flex-between">
        <div class="zzl-search-list">
          <div class="zzl-search-item">
            <p>菜名</p>
            <el-input
              v-model="search.kw"
              placeholder="输入菜名回车搜索"
              clearable
              @change="searchData"
            ></el-input>
          </div>
          <div class="zzl-search-item">
            <el-button type="primary" @click="searchData">查询</el-button>
          </div>
        </div>
        <div class="zzl-search-list">
          <div class="zzl-search-item">
            <el-button type="primary" @click="addOrUpdate(1)">添加</el-button>
          </div>
        </div>
      </div>
      <div class="zzl-table-list">
        <el-table :data="tableList" max-height="640px" style="width: 100%">
          <el-table-column
            prop="name"
            label="菜名"
            min-width="300"
            align="center"
            fixed="left"
          >
          </el-table-column>
          <el-table-column label="图片" min-width="150" align="center">
            <template slot-scope="scope">
              <viewer>
                <img :src="scope.row.img" />
              </viewer>
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            label="价格/元"
            min-width="80"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="updated_user"
            label="更新人"
            min-width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="updated_time"
            label="更新时间"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="created_user"
            label="创建人"
            min-width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="created_time"
            label="创建时间"
            min-width="160"
            align="center"
          >
          </el-table-column> -->
          <el-table-column
            prop="created_time"
            label="操作"
            min-width="150"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <div class="flex-center-center">
                <span class="action-text" @click="addOrUpdate(2, scope.row)"
                  >编辑</span
                >
                <span class="action-text" @click="deleteData(scope.row)"
                  >删除</span
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex-end-center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.pageNum"
            :page-size="pagination.pageSize"
            :total="pagination.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :title="formTitle"
      :visible.sync="formVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
      append-to-body
    >
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-form-item prop="name" label="菜名">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item prop="price" label="价格/元">
          <el-input v-model="form.price" type="number"></el-input>
        </el-form-item>
        <el-form-item prop="img" label="图片">
          <UploadImage
            :uploadTip="'支持/JPG/PNG/GIF格式，大小不超过1M'"
            v-model="form.img"
          ></UploadImage>
        </el-form-item>
      </el-form>
      <div class="flex-center-center">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UploadImage from "@/components/UploadImage.vue";

export default {
  name: "meal",
  components: {
    UploadImage,
  },
  data() {
    return {
      tableList: [],
      pagination: {
        pageNum: 1,
        pageSize: 20,
        count: 0,
      },
      search: {
        kw: "",
      },

      formVisible: false,
      formTitle: "",
      form: {
        name: "",
        price: "",
        img: "",
        id: 0,
      },
      rules: {
        name: [{ required: true, message: "请输入菜名", trigger: "blur" }],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
        img: [{ required: true, message: "请上传图片", trigger: "change" }],
      },
    };
  },
  methods: {
    addOrUpdate(type, data) {
      this.formVisible = true;

      if (type == 1) {
        this.formTitle = "添加";
      } else {
        this.formTitle = "修改";
        this.form = JSON.parse(JSON.stringify(data));
      }
    },
    deleteData(data) {
      this.$confirm("该操作将永久删除本条数据,请确认是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.zzlHttp.post(this.zzlApi.delMeal, {
            id: data.id,
          });
          if (res.code == 0) {
            this.$message.success("删除成功");
            this.searchData();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    confirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let params = {
            ...this.form,
          };
          const res = await this.zzlHttp.post(
            this.zzlApi.addOrUpdateMeal,
            params
          );
          if (res.code == 0) {
            if (params.id == 0) {
              this.$message.success("添加成功");
            } else {
              this.$message.success("更新成功");
            }
            this.getList();
            this.closeForm();
          } else {
            this.$message.error(res.msg);
          }
        }
      });
    },
    cancel() {
      this.closeForm();
    },
    closeForm() {
      this.form = {
        name: "",
        price: "",
        img: "",
        id: 0,
      };
      this.$refs.form.resetFields();
      this.formVisible = false;
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pagination.pageNum = 1;
      this.pagination.pageSize = val;
      this.getList();
    },
    searchData() {
      this.pagination.pageNum = 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      let params = {
        ...this.pagination,
        ...this.search
      };
      const res = await this.zzlHttp.post(this.zzlApi.getMealList, params);
      if (res.code === 0 && res.data) {
        this.pagination.count = res.data.count || 0;
        this.tableList = res.data.list || [];
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
</style>
